import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useState } from 'react';
import Avvvatars from 'avvvatars-react';
import { userAction } from '../../actions/userAction';
import { useFrontContext } from '../../providers/frontContext';
import { Container, Card, CardHeader, CardBody, Collapse } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPodcast, faIdCard, faCrown, faMicrophone, faCoffee, faFilePen } from '@fortawesome/free-solid-svg-icons';
import UserDetail from "./userDetail";
import ChannelEngagement from "../dashboard/channelEngagement";
import Messages from "./messages";
import UserChannel from "./userChannel";
import EpisodeEngagement from "../dashboard/episodeDetail"
import MessageBoardEngagement from "../dashboard/messageBoardEngagement";
import { DABInlineLoading } from '../../components/dab'
import { getUserAccessToken } from '../../services/selectors/Accounts';
import { validateAccessTokenExpiry } from '../common/functions';

interface IProps {
	dispatch: Dispatch<any>;
	userData: any;
}

const FrontDetail: React.SFC<IProps> = ({ dispatch, userData }) => {
	const context = useFrontContext();

	const frontUser = sessionStorage.getItem("frontUser")
	const frontEmail = sessionStorage.getItem("frontEmail")
	const recipientEmail = (context && context.conversation && context.conversation.recipient) ? context.conversation.recipient.handle : frontEmail ? frontEmail: undefined;
	const recipientName = (context && context.conversation && context.conversation.recipient) ? context.conversation.recipient.name : frontUser ? frontUser :"Not found";

	const [isDetailLoaded, setIsDetailLoaded] = useState(false);
	const [isWaitingForToken, setIsWaitingForToken] = useState(false);
	const initialUser = { userId: 0, firstName: "", lastName: "" }
	const [user, setUser] = useState(initialUser);
	const [isValidUser, setIsValidUser] = useState(true)
	const [error, setError] = useState("");
	const [open, setOpen] = useState("");

	React.useEffect(() => {
		setIsDetailLoaded(false);
		var validToken = validateAccessTokenExpiry();
		if (!validToken) {
			setIsWaitingForToken(true);
		}
		else
		{
			setIsWaitingForToken(false);
			dispatch(userAction.userGetDetail(-1, recipientEmail));
		}
	}, [recipientEmail]);

	if (userData) {
		if (userData.isDetailComplete) {
			if (!isDetailLoaded && userData.item) {
				setIsDetailLoaded(true);
				setUser(userData.item);
				setIsValidUser(true);
			}
		}
		if (userData.isError) {
			setUser(initialUser)
			userData.isError = false;
			setIsValidUser(false);
			setError(userData.status);
			setIsDetailLoaded(true);
		}
	}

	const handleToggle = (value) => {
		setOpen(value);
	}

	return (
		<div className="front-detail">
			{(userData.isLoading) ?
				< div className="front-spinner" style={{ height: window.innerHeight - 200 }}> <DABInlineLoading /> </div> :
				<Container>
					<Card>
						<CardBody>
							<>
								<div className="avatar">
									<Avvvatars data-testid="avatart-img"
										value={recipientEmail ? recipientEmail : frontEmail ? frontEmail : "Not found"}
										displayValue={(recipientName != undefined && recipientName != null) ?
											recipientName.split(" ").length > 1 ? recipientName.split(" ")[0].charAt(0) + recipientName.split(" ")[1].charAt(0) : ""
											: ""} size={80} />
								</div>
								<div className="text-center">
									<span> <a href={"/dashboard?id=" + user.userId} className="detail-link0" target="_blank" data-testid="frontusername">{recipientName} </a> </span><br />
									<span className="front-email"><a href={"/dashboard?id=" + user.userId} className="detail-link1" target="_blank" data-testid="frontuseremail" >{recipientEmail}</a> </span>
								</div>
							</>
							{!isWaitingForToken && isValidUser && user.userId > 0 && (
								<div className="dabFrontDetail">
									<Card key='id1'>
										<CardHeader onClick={() => handleToggle('id1')}>
											<div>
												<FontAwesomeIcon icon={faIdCard} color="#00bfff" size="2x" width="35" />
												<span className="frontCardHeader" data-testid="userdetails">User Details</span>
											</div>
										</CardHeader>
										<Collapse isOpen={open === 'id1'}>
											<CardBody>
												<UserDetail userId={user.userId} />
											</CardBody>
										</Collapse>
									</Card>
									<Card key='id2'>
										<CardHeader onClick={() => handleToggle('id2')}>
											<div>
												<FontAwesomeIcon icon={faPodcast} color="#8000ff" size="2x" width="35" />
												<span className="frontCardHeader" data-testid="frontchannel">Channels</span>
											</div>
										</CardHeader>
										<Collapse isOpen={open === 'id2'}>
											<CardBody>
												<UserChannel id={user.userId} />
											</CardBody>
										</Collapse>
									</Card>
									<Card key='id3'>
										<CardHeader onClick={() => handleToggle('id3')}>
											<div>
												<FontAwesomeIcon icon={faCrown} color="#ffbf00" size="2x" width="35" />
												<span className="frontCardHeader" data-testid="frontchanneleng">Channel Engagement</span>
											</div>
										</CardHeader>
										<Collapse isOpen={open === 'id3'}>
											<CardBody>
												<ChannelEngagement userId={user.userId} fromPage={"front"} />
											</CardBody>
										</Collapse>
									</Card>
									<Card key='id4'>
										<CardHeader onClick={() => handleToggle('id4')}>
											<div>
												<FontAwesomeIcon icon={faMicrophone} color="#04AA6D" size="2x" width="35" />
												<span className="frontCardHeader" data-testid="frontepisodeeng">Episode Engagement</span>
											</div>
										</CardHeader>
										<Collapse isOpen={open === 'id4'}>
											<CardBody>
												<EpisodeEngagement userId={user.userId} title="Front" />
											</CardBody>
										</Collapse>
									</Card>
									<Card key='id5'>
										<CardHeader onClick={() => handleToggle('id5')}>
											<div>
												<FontAwesomeIcon icon={faCoffee} color="#999" size="2x" width="35" />
												<span className="frontCardHeader" data-testid="frontmsgeng">Message Board Engagement</span>
											</div>
										</CardHeader>
										<Collapse isOpen={open === 'id5'}>
											<CardBody>
												<MessageBoardEngagement userId={user.userId} fromPage={"front"} />
											</CardBody>
										</Collapse>
									</Card>
									<Card key='id6'>
										<CardHeader onClick={() => handleToggle('id6')}>
											<div>
												<FontAwesomeIcon icon={faFilePen} color="#0080ff" size="2x" width="35" />
												<span className="frontCardHeader" data-testid="frontmsg">Prayer Hotline</span>
											</div>
										</CardHeader>
										<Collapse isOpen={open === 'id6'}>
											<CardBody>
												<Messages userId={user.userId} fromPage={"front"} />
											</CardBody>
										</Collapse>
									</Card>
								</div>
							)}

							{!isValidUser && user.userId <= 0 &&
								<div className="not-found">
									<p className="invalid-text">
										{error === 'Invalid user.' ? "User not found" : "UnAuthorized"}
									</p>
								</div>
							}

							{isWaitingForToken &&
								<div>
									<div><br /></div>
									<div>Access grant / renewal is in progress. Please wait for a moment and click the link given below. </div>
									<div><br/></div>
									<div>If you could not view details after reload, please logout and login again. Sorry for the inconvenience.</div>
									<div className="text-center">
										<div className="front-email"><a href={"/front"} className="detail-link1">Reload</a></div>
									</div>
								</div>
							}
						</CardBody>
					</Card>
				</Container>}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { userData } = state;
	return { userData };
};

export default connect(mapStateToProps)(FrontDetail);